import { render } from "./MyMembershipCard.vue?vue&type=template&id=8884b40e&scoped=true"
import script from "./MyMembershipCard.vue?vue&type=script&lang=js"
export * from "./MyMembershipCard.vue?vue&type=script&lang=js"

import "./MyMembershipCard.vue?vue&type=style&index=0&id=8884b40e&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8884b40e"]])

export default __exports__